import api from './api'

export const invoiceService = {
  getAll: (params?: { search?: string; status?: string; page?: number; limit?: number }) =>
    api.get('/invoices', { params }),

  getById: (id: number | string) =>
    api.get(`/invoices/${id}`),

  getBySale: (saleId: number | string) =>
    api.get(`/invoices/sale/${saleId}`),

  create: (data: any) =>
    api.post('/invoices', data),

  update: (id: number | string, data: any) =>
    api.put(`/invoices/${id}`, data),

  delete: (id: number | string) =>
    api.delete(`/invoices/${id}`),

  recordPayment: (id: number | string, data: { amount: number; payment_method_id?: number; reference_number?: string }) =>
    api.post(`/invoices/${id}/payment`, data),
}
